// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sidebar[data-v-a0184fd6]>:not(:last-child){margin-bottom:20px}.sidebar--sticky[data-v-a0184fd6]{align-self:start;position:-webkit-sticky;position:sticky;top:0}[data-v-a0184fd6] .sidebar-cls-shield{min-height:250px}@media(min-width:768px){[data-v-a0184fd6] .sidebar-cls-shield{min-height:600px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
